import { render, staticRenderFns } from "./KarlilikRaporu.vue?vue&type=template&id=0f21d4b0&"
import script from "./KarlilikRaporu.vue?vue&type=script&lang=js&"
export * from "./KarlilikRaporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports